<template>
  <b-row>
    <b-col
      md="12"
      lg="12"
      class="filter-heading"
    >
      <h4>{{ $t('DEBTIA_DEBTOR_FILTER') }}</h4>
      <b-alert
        v-if="debtorAllowedFilters.length < 1"
        variant="warning"
        show
      >
        <div class="alert-body">
          <span>{{ $t('DEBTIA_NO_FILTER_SELECTED') }}!</span>
        </div>
      </b-alert>
    </b-col>
    <b-col
      v-if="debtorAllowedFilters.indexOf('city') > -1"
      md="6"
      lg="6"
    >
      <validation-provider
        #default="{ errors }"
        name="City"
        rules="required"
      >
        <b-form-group
          :label="$t('DEBTIA_CITY')"
          label-for="City"
        >
          <v-select
            v-model="debtorFiltersValues.city"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="cities"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            input-id="cities"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col
      v-if="debtorAllowedFilters.indexOf('countries') > -1"
      md="6"
      lg="6"
    >
      <validation-provider
        #default="{ errors }"
        name="Countries"
        rules="required"
      >
        <b-form-group
          :label="$t('DEBTIA_COUNTRIES')"
          label-for="countries"
        >
          <v-select
            v-model="debtorFiltersValues.countries"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="countries"
            :reduce="val => val.value"
            :clearable="false"
            input-id="countries"
            multiple
            :value="'Select Countries'"
          >
            <template
              #selected-option-container="{ option }"
            >
              <div class="vs__selected">
                {{ $t(option.label) }}
                <button
                  type="button"
                  class="vs__deselect"
                  @click="deselectcountry(option.value)"
                >
                  <feather-icon
                    icon="XIcon"
                    size="18"
                  />
                </button>
              </div>
            </template>
            <template
              slot="option"
              slot-scope="option"
            >
              {{ $t(option.label) }}
            </template>
          </v-select>
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col
      v-if="debtorAllowedFilters.indexOf('total_cases') > -1"
      md="6"
      lg="6"
    >
      <b-form-group
        :label="$t('DEBTIA_CASES')"
        label-for="Cases"
      >
        <b-form-radio-group
          v-model="debtorFiltersValues.total_cases.total_cases_comparison_type"
          :options="numberComparisonOptions"
          class="demo-inline-spacing margin-botton-3"
          value-field="value"
          text-field="text"
          disabled-field="disabled"
        />
        <b-input-group
          v-if="debtorFiltersValues.total_cases.total_cases_comparison_type && debtorFiltersValues.total_cases.total_cases_comparison_type !== '<>'"
          class="input-group-merge"
        >
          <b-input-group-prepend is-text>
            {{ $t('DEBTIA_CASES') }} {{ debtorFiltersValues.total_cases.total_cases_comparison_type === '=' ? $t('DEBTIA_EQUALS_TO')+' ' : debtorFiltersValues.total_cases.total_cases_comparison_type === '>' ? ' '+$t('DEBTIA_GREATER_THAN') : ' '+$t('DEBTIA_LESS_THAN')+' ' }}
          </b-input-group-prepend>
          <b-form-input
            v-model="debtorFiltersValues.total_cases.total_cases_till_case_no"
            :placeholder="$t('DEBTIA_CASE_NO')"
          />
        </b-input-group>
        <b-input-group
          v-else-if="debtorFiltersValues.total_cases.total_cases_comparison_type && debtorFiltersValues.total_cases.total_cases_comparison_type === '<>'"
          class="input-group-merge"
        >
          <b-input-group-prepend is-text>
            {{ $t('DEBTIA_FROM') }}
          </b-input-group-prepend>
          <b-form-input
            v-model="debtorFiltersValues.total_cases.total_cases_from_case_no"
            :placeholder="$t('DEBTIA_CASE_NO')"
          />
          <b-input-group-prepend is-text>
            {{ $t('DEBTIA_TILL') }}
          </b-input-group-prepend>
          <b-form-input
            v-model="debtorFiltersValues.total_cases.total_cases_till_case_no"
            :placeholder="$t('DEBTIA_CASE_NO')"
          />
        </b-input-group>
        <b-form-input
          v-else
          placeholder="Select Operation"
          disabled
        />
        <validation-provider
          #default="{ errors }"
          name="Cases"
          rules="required"
        >
          <small class="text-danger">{{ errors[0] }}</small>
          <b-form-input
            v-model="numberOfCases"
            style="display: none;"
            disabled
          />
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="debtorAllowedFilters.indexOf('active_cases') > -1"
      md="6"
      lg="6"
    >
      <b-form-group
        :label="$t('DEBTIA_ACTIVE_CASES')"
        label-for="Active Cases"
      >
        <b-form-radio-group
          v-model="debtorFiltersValues.active_cases.active_cases_comparison_type"
          :options="numberComparisonOptions"
          class="demo-inline-spacing margin-botton-3"
          value-field="value"
          text-field="text"
          disabled-field="disabled"
        />
        <b-input-group
          v-if="debtorFiltersValues.active_cases.active_cases_comparison_type && debtorFiltersValues.active_cases.active_cases_comparison_type !== '<>'"
          class="input-group-merge"
        >
          <b-input-group-prepend is-text>
            {{ $t('DEBTIA_CASES') }} {{ debtorFiltersValues.active_cases.active_cases_comparison_type === '=' ? 'equal to ' : debtorFiltersValues.active_cases.active_cases_comparison_type === '>' ? ' greater than' : ' less than ' }}
          </b-input-group-prepend>
          <b-form-input
            v-model="debtorFiltersValues.active_cases.active_cases_till_case_no"
            :placeholder="$t('DEBTIA_CASE_NO')"
          />
        </b-input-group>
        <b-input-group
          v-else-if="debtorFiltersValues.active_cases.active_cases_comparison_type && debtorFiltersValues.active_cases.active_cases_comparison_type === '<>'"
          class="input-group-merge"
        >
          <b-input-group-prepend is-text>
            {{ $t('DEBTIA_FROM') }}
          </b-input-group-prepend>
          <b-form-input
            v-model="debtorFiltersValues.active_cases.active_cases_from_case_no"
            :placeholder="$t('DEBTIA_CASE_NO')"
          />
          <b-input-group-prepend is-text>
            {{ $t('DEBTIA_TILL') }}
          </b-input-group-prepend>
          <b-form-input
            v-model="debtorFiltersValues.active_cases.active_cases_till_case_no"
            :placeholder="$t('DEBTIA_CASE_NO')"
          />
        </b-input-group>
        <b-form-input
          v-else
          placeholder="Select Operation"
          disabled
        />
        <validation-provider
          #default="{ errors }"
          name="Active Cases"
          rules="required"
        >
          <small class="text-danger">{{ errors[0] }}</small>
          <b-form-input
            v-model="numberOfActiveCases"
            style="display: none;"
            disabled
          />
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="debtorAllowedFilters.indexOf('custom_fields') > -1"
      md="6"
      lg="6"
    >
      <validation-provider
        #default="{ errors }"
        name="Custom Field(s)"
        rules="required"
      >
        <b-form-group
          :label="$t('DEBTIA_CUSTOM_FIELDS')"
          label-for="Custom Fields"
        >
          <v-select
            v-model="customFields"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="customVariables"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            input-id="Custom Fields"
            @option:deselected="customVariableChange($event, 0)"
            @option:selected="customVariableChange($event, 1)"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col
      v-if="debtorAllowedFilters.indexOf('custom_fields') > -1 && debtorFiltersValues.custom_fields.length > 0"
      md="12"
      lg="12"
    >
      <fields-file
        :custom-variables="debtorFiltersValues.custom_fields"
        :airports="airports"
      />
    </b-col>
    <date-field
      v-if="debtorAllowedFilters.indexOf('creation_date') > -1"
      :label="'DEBTIA_CREATION_DATE'"
      :label-for="'creation_date'"
      :case-allowed-filters="debtorAllowedFilters"
      :date-values="debtorFiltersValues.creation_date"
    />
  </b-row>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BInputGroup, BFormRadioGroup, BInputGroupPrepend, BAlert,
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import countries from '@/countries'
import DateField from './DateField.vue'
import FieldsFile from './customfields/FieldsFile.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    ValidationProvider,
    BFormInput,
    vSelect,
    BInputGroup,
    BFormRadioGroup,
    BInputGroupPrepend,
    BAlert,
    DateField,
    FieldsFile,
  },
  directives: {
    Ripple,
  },
  props: {
    filterId: {
      type: Number,
      required: true,
    },
    filterDetails: {
      type: Object,
      required: true,
    },
    filterValue: {
      type: String,
      required: true,
    },
    filterBit: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      customFields: [],
      selectedComparison: null,
      required,
      selectedConfirmation: null,
      numberComparisonOptions: [
        { text: 'Greater Than', value: '>', disabled: false },
        { text: 'Less Than', value: '<', disabled: false },
        { html: 'Equals to', value: '=', disabled: false },
        { text: 'Between', value: '<>', disabled: false },
      ],
      debtorFiltersValues: {
        city: [],
        countries: [],
        creation_date: {
          is_dynamic: false,
          // creation_fieldValue: null,
          no_of_days: null,
          from_date: {
            is_dynamic: false,
            no_of_days: null,
            value: null,
          },
          till_date: {
            is_dynamic: false,
            no_of_days: null,
            value: null,
          },
          value: null,
        },
        total_cases: {
          total_cases_comparison_type: null,
          total_cases_from_case_no: null,
          total_cases_till_case_no: null,
        },
        active_cases: {
          active_cases_comparison_type: null,
          active_cases_from_case_no: null,
          active_cases_till_case_no: null,
        },
        custom_fields: [],
      },
      debtorAllowedFilters: [],
      customVariables: [],
      cities: [],
      airports: [],
      countries,
      numberOfCases: null,
      numberOfActiveCases: null,
      firstLoad: true,
      activefirstLoad: true,
      firstCreationDateLoad: true,
    }
  },
  watch: {
    filterDetails: {
      handler() {
        this.debtorFiltersValues = this.filterDetails
      },
    },
    filterBit: {
      handler() {
        this.filterChange()
      },
    },
    'debtorFiltersValues.total_cases.total_cases_comparison_type': {
      handler() {
        if (!this.firstLoad) {
          this.debtorFiltersValues.total_cases.total_cases_from_case_no = null
          this.debtorFiltersValues.total_cases.total_cases_till_case_no = null
        }
        if (this.firstLoad) this.firstLoad = false
      },
    },
    'debtorFiltersValues.active_cases.active_cases_comparison_type': {
      handler() {
        if (!this.activefirstLoad) {
          this.debtorFiltersValues.active_cases.active_cases_from_case_no = null
          this.debtorFiltersValues.active_cases.active_cases_till_case_no = null
        }
        if (this.activefirstLoad) this.activefirstLoad = false
      },
    },
    'debtorFiltersValues.total_cases.total_cases_till_case_no': {
      handler() {
        this.checkCaseValidity(this.debtorFiltersValues.total_cases, 0)
      },
    },
    'debtorFiltersValues.total_cases.total_cases_from_case_no': {
      handler() {
        this.checkCaseValidity(this.debtorFiltersValues.total_cases, 0)
      },
    },
    'debtorFiltersValues.active_cases.active_cases_till_case_no': {
      handler() {
        this.checkCaseValidity(this.debtorFiltersValues.active_cases, 1)
      },
    },
    'debtorFiltersValues.active_cases.active_cases_from_case_no': {
      handler() {
        this.checkCaseValidity(this.debtorFiltersValues.active_cases, 1)
      },
    },
  },
  created() {
    this.getCities()
    this.getCustomVariables()
    if (this.filterId) this.changeDebtorFiltersValues()
    this.debtorAllowedFilters = Object.keys(this.filterDetails)
    if (this.filterDetails.custom_fields) this.mapCustomVariableValues()
  },
  methods: {
    mapCustomVariableValues() {
      this.debtorFiltersValues.custom_fields = this.filterDetails.custom_fields
      this.customFields = this.filterDetails.custom_fields.map(x => Number(x.id))
    },
    customVariableChange(event, added) {
      if (added) {
        const customField = event[event.length - 1]
        const obj = {
          id: customField.value,
          data: {
            type: customField.type,
            label: customField.label,
            options: customField.options,
            value: null,
          },
        }
        this.debtorFiltersValues.custom_fields.push(obj)
      } else {
        this.debtorFiltersValues.custom_fields
          .splice(this.debtorFiltersValues.custom_fields
            .indexOf(this.debtorFiltersValues.custom_fields
              .filter(element => element.id === event.value)[0]),
          1)
      }
    },
    getCustomVariables() {
      const url = '/user-settings/custom-variables-dropdown?type=debtor'
      axios.get(url).then(response => {
        if (response.status === 200) {
          this.customVariables = response.data.data.variables
          this.airports = response.data.data.options
        }
      })
    },
    changeDebtorFiltersValues() {
      if (this.filterDetails.city) {
        this.debtorFiltersValues.city = this.filterDetails.city.map(x => Number(x))
      }
      if (this.filterDetails.countries) {
        this.debtorFiltersValues.countries = this.filterDetails.countries.map(x => Number(x))
      }
      if (this.filterDetails.creation_date) {
        if (this.filterDetails.creation_date.is_dynamic) {
          this.debtorFiltersValues.creation_date.is_dynamic = this.filterDetails.creation_date.is_dynamic
          this.debtorFiltersValues.creation_date.no_of_days = this.filterDetails.creation_date.no_of_days
        } else {
          this.debtorFiltersValues.creation_date = this.filterDetails.creation_date
        }
      }
      if (this.filterDetails.total_cases) {
        this.debtorFiltersValues.total_cases.total_cases_comparison_type = this.filterDetails.total_cases.total_cases_comparison_type
        this.debtorFiltersValues.total_cases.total_cases_till_case_no = this.filterDetails.total_cases.total_cases_till_case_no
        this.debtorFiltersValues.total_cases.total_cases_from_case_no = this.filterDetails.total_cases.total_cases_from_case_no ? this.filterDetails.total_cases.total_cases_from_case_no : null
      }
      if (this.filterDetails.active_cases) {
        this.debtorFiltersValues.active_cases.active_cases_comparison_type = this.filterDetails.active_cases.active_cases_comparison_type
        this.debtorFiltersValues.active_cases.active_cases_till_case_no = this.filterDetails.active_cases.active_cases_till_case_no
        this.debtorFiltersValues.active_cases.active_cases_from_case_no = this.filterDetails.active_cases.active_cases_from_case_no ? this.filterDetails.active_cases.active_cases_from_case_no : null
      }
    },
    checkCaseValidity(obj, type) {
      let symbol = null
      let fromCaseNo = null
      let tillCaseNo = null
      if (type === 0) {
        this.numberOfCases = null
        symbol = obj.total_cases_comparison_type
        fromCaseNo = obj.total_cases_from_case_no
        tillCaseNo = obj.total_cases_till_case_no
      } else {
        this.numberOfActiveCases = null
        symbol = obj.active_cases_comparison_type
        fromCaseNo = obj.active_cases_from_case_no
        tillCaseNo = obj.active_cases_till_case_no
      }
      if ((symbol === '<>' && fromCaseNo && tillCaseNo) || (symbol !== '<>' && tillCaseNo)) {
        if (type === 0) {
          this.numberOfCases = tillCaseNo
        } else {
          this.numberOfActiveCases = tillCaseNo
        }
      }
    },
    deselectcountry(id) {
      this.debtorFiltersValues.countries.splice(this.debtorFiltersValues.countries.indexOf(id), 1)
    },
    filterChange() {
      const index = this.debtorAllowedFilters.indexOf(this.filterValue)
      if (index < 0) {
        this.debtorAllowedFilters.push(this.filterValue)
      } else {
        this.debtorAllowedFilters.splice(this.debtorAllowedFilters.indexOf(this.filterValue), 1)
      }
    },
    getCities() {
      const url = '/settings/get-cities-dropdown?country=Danmark'
      axios.get(url).then(response => {
        if (response.status === 200) {
          const cities = response.data.data
          this.cities = cities
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.margin-botton-3 label span {
  font-size: 10px !important;
}

.margin-botton-3 .custom-radio{
  margin-bottom: 6px;
  margin-top: 0px !important;
}
</style>
